import React, { Fragment } from "react";
import { ExamStatus, ExamTypeArr, ExamTypes, Semesters, UserTypeId } from "../../common/const";
import { Box, Grid, Typography } from "@mui/material";
import CommonButton from "../../common/components/CommonButton";
import theme from "../../theme";
import CommonCard from "../../common/components/CommonCard";
import moment from "moment";
import { Add } from "@mui/icons-material";
import { useSelector } from "react-redux";

const ExamListing = ({
    setAddOpen,
    setEdit,
    filters,
    setFilters,
    exams,
    setExams,
    examType,
    setExamType
}) => {
    const { user } = useSelector((state) => state.auth);
    return (
        <Fragment>
            <Box display="flex" justifyContent="space-between" mt={2}>
                <Box display="flex" gap={1}>
                    <CommonButton
                        label="SAT / ACT"
                        width="120px"
                        fontWeight={600}
                        height="35px"
                        color={examType === ExamTypes.ACT_SAT ? theme.palette.secondary.main : theme.palette.background.dark}
                        background={examType === ExamTypes.ACT_SAT ? theme.palette.primary.main : 'white'}
                        handleClick={() => {
                            setExamType(ExamTypes.ACT_SAT);
                            setFilters((prev) => ({
                                ...prev,
                                exam_type: ExamTypes.ACT_SAT,
                                semester: ''
                            }));
                            setExams([]);
                        }}
                        marginBottom="0px"
                    />
                    <CommonButton
                        label="Academics"
                        width="120px"
                        height="35px"
                        fontWeight={600}
                        color={examType === ExamTypes.ACADEMIC ? theme.palette.secondary.main : theme.palette.background.dark}
                        background={examType === ExamTypes.ACADEMIC ? theme.palette.primary.main : 'white'}
                        handleClick={() => {
                            setExamType(ExamTypes.ACADEMIC);
                            setFilters((prev) => ({
                                ...prev,
                                exam_type: ExamTypes.ACADEMIC,
                                semester: Semesters?.["Semester 1"]
                            }));
                            setExams([]);
                        }}
                        marginBottom="0px"
                    />
                    <CommonButton
                        label="AP Exams"
                        width="120px"
                        height="35px"
                        fontWeight={600}
                        color={examType === ExamTypes.APEXAM ? theme.palette.secondary.main : theme.palette.background.dark}
                        background={examType === ExamTypes.APEXAM ? theme.palette.primary.main : 'white'}
                        handleClick={() => {
                            setExamType(ExamTypes.APEXAM);
                            setFilters((prev) => ({
                                ...prev,
                                exam_type: ExamTypes.APEXAM,
                                semester: Semesters?.["Semester 1"]
                            }));
                            setExams([]);
                        }}
                        marginBottom="0px"
                    />
                    <CommonButton
                        label="Skills"
                        width="70px"
                        height="35px"
                        fontWeight={600}
                        color={examType === ExamTypes.SKILLS ? theme.palette.secondary.main : theme.palette.background.dark}
                        background={examType === ExamTypes.SKILLS ? theme.palette.primary.main : 'white'}
                        handleClick={() => {
                            setExamType(ExamTypes.SKILLS);
                            setFilters((prev) => ({
                                ...prev,
                                exam_type: ExamTypes.SKILLS,
                                semester: ''
                            }));
                            setExams([]);
                        }}
                        marginBottom="0px"
                    />
                </Box>
                {user?.user_type_id === UserTypeId.Student &&
                    (<CommonButton
                        label={`Add New ${examType === ExamTypes.ACT_SAT ? 'SAT/ACT' : examType === ExamTypes.ACADEMIC ? 'Academic' : examType === ExamTypes.APEXAM ? 'AP' : 'Skill'} Exam`}
                        marginBottom="0px"
                        startIcon={<Add />}
                        fontWeight={600}
                        width={examType === ExamTypes.ACT_SAT ? "22%" : '23%'}
                        handleClick={() => {
                            setAddOpen(true);
                            setEdit(null);
                        }}
                    />)}
            </Box>
            {[ExamTypes?.APEXAM, ExamTypes?.ACADEMIC]?.includes(examType) && (
                <Box mt={2} display="flex" gap={1}>
                    <CommonButton
                        label="Semester 1"
                        fontWeight={600}
                        color={filters.semester === Semesters?.["Semester 1"] ? theme.palette.secondary.main : theme.palette.background.dark}
                        background={filters.semester === Semesters?.["Semester 1"] ? theme.palette.primary.main : 'white'}
                        handleClick={() => setFilters((prev) => ({
                            ...prev,
                            semester: Semesters?.["Semester 1"]
                        }))}
                        marginBottom="0px"
                        height="35px"
                    />
                    <CommonButton
                        label="Semester 2"
                        fontWeight={600}
                        color={filters.semester === Semesters?.["Semester 2"] ? theme.palette.secondary.main : theme.palette.background.dark}
                        background={filters.semester === Semesters?.["Semester 2"] ? theme.palette.primary.main : 'white'}
                        handleClick={() => setFilters((prev) => ({
                            ...prev,
                            semester: Semesters?.["Semester 2"]
                        }))}
                        marginBottom="0px"
                        height="35px"
                    />
                </Box>
            )}
            <Grid
                container
                spacing={2}
                sx={{
                    height: '45vh',
                    overflow: 'auto'
                }}
            >
                {exams.length > 0 ? exams.map((a, index) => (
                    <Grid item sm={4} key={index}>
                        <CommonCard
                            paddingBottom="0px"
                            borderRadius={2}
                            border={`1px solid #0000001A`}
                            padding="13px 10px 13px 10px"
                            content={
                                <Fragment>
                                    <Box display="flex" justifyContent={"space-between"} alignItems="center">
                                        {a.exam_date ? (
                                            <Box display="flex" gap={0.5}>
                                                <img
                                                    src='/Images/Calendar.png'
                                                    style={{
                                                        width: 20,
                                                        height: 20
                                                    }}
                                                    alt=''
                                                />
                                                <Typography fontSize={14} color={theme.palette.background.dark}>Exam Date <span style={{ color: theme.palette.secondary.main, fontWeight: 600 }}>{a.exam_date ? moment(a.exam_date)?.format('DD MMM, YYYY') : ''}</span></Typography>
                                            </Box>
                                        ) : (
                                            <Box display="flex" gap={0.5}>
                                                <img
                                                    src='/Images/Calendar.png'
                                                    style={{
                                                        width: 20,
                                                        height: 20
                                                    }}
                                                    alt=''
                                                />
                                                <Typography fontSize={14} color={theme.palette.background.dark}>Exam Date <span style={{ color: theme.palette.secondary.main, fontWeight: 600 }}>{a.subjects?.length > 0 ? moment(a.subjects
                                                    .map(s => new Date(s.exam_date))
                                                    .sort((a, b) => a - b)[0])?.format('DD MMM, YYYY') : ''}</span></Typography>
                                            </Box>
                                        )}
                                        {user?.user_type_id === UserTypeId.Student &&
                                            (<Box display="flex" gap={0.5} alignItems="center">
                                                <CommonButton
                                                    label="Edit"
                                                    color="black"
                                                    background="white"
                                                    height="25px"
                                                    width="40px"
                                                    marginBottom="0px"
                                                    border={`1px solid #0000001A`}
                                                    handleClick={() => {
                                                        setAddOpen(true);
                                                        setEdit(a)
                                                    }}
                                                />
                                            </Box>)}
                                    </Box>
                                    <Box display="flex" gap={0.5} mt={1}>
                                        <Box sx={{ background: '#FAFAFA', padding: '2px 10px 2px 10px', borderRadius: 1 }}>
                                            <Typography color={theme.palette.background.dark} fontSize={14}>{['SAT', 'ACT'].includes(a.test_type) ? 'SAT/ACT' : a.test_type ? ExamTypeArr.find((i) => i.value === a.test_type)?.label : ''}</Typography>
                                        </Box>
                                        <Box sx={{ background: theme.palette.secondary.main, padding: '2px 10px 2px 10px', borderRadius: 1 }}>
                                            <Typography color={'white'} fontSize={14}>{a.status ? ExamStatus.find((i) => i.value === a.status)?.label : ''}</Typography>
                                        </Box>
                                        {a.gpa && (
                                            <Box sx={{ padding: '2px 10px 2px 10px' }}>
                                                <Typography color={theme.palette.background.dark} fontSize={14}>GPA <span style={{ fontWeight: 600, color: 'black', marginLeft: 2 }}>{a.gpa}</span></Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    {a?.subjects?.length > 0 && (
                                        <CommonCard
                                            paddingBottom="0px"
                                            borderRadius={1}
                                            background={'#FEF9C2'}
                                            padding="10px 13px 10px 13px"
                                            content={
                                                <Fragment>
                                                    <Typography fontWeight={600}>Subject</Typography>
                                                    <Box
                                                        sx={{
                                                            height: '9vh',
                                                            overflow: 'auto'
                                                        }}
                                                    >
                                                        {a.subjects.map((i, ind) => (
                                                            <CommonCard
                                                                key={ind}
                                                                marginTop="10px"
                                                                paddingBottom="0px"
                                                                padding="8px 13px 8px 13px"
                                                                borderRadius={1}
                                                                content={
                                                                    <Fragment>
                                                                        <Typography fontWeight={600} fontSize={15}>{i.name}</Typography>
                                                                        <Typography fontSize={14} color={theme.palette.background.dark}>Exam Date {i.exam_date ? moment(i.exam_date)?.format('DD MMM, YYYY') : ''}</Typography>
                                                                    </Fragment>
                                                                }
                                                            />
                                                        ))}
                                                    </Box>
                                                </Fragment>
                                            }
                                        />
                                    )}
                                </Fragment>
                            }
                        />
                    </Grid>
                )) : (
                    <Grid item md={12}>
                        <Box mt={5} display="flex" justifyContent="center">
                            <Typography>Exam Not Found</Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Fragment>
    )
}

export default ExamListing;